import { render } from "./CrudCarreta.vue?vue&type=template&id=3e95ce1b"
import script from "./CrudCarreta.vue?vue&type=script&lang=ts"
export * from "./CrudCarreta.vue?vue&type=script&lang=ts"
script.render = render

export default script